export default "__VITE_ASSET__72602078__"